// extracted by mini-css-extract-plugin
export var currencyInput = "_kl-1";
export var currencySymbol = "_kl-0";